export const AVAILABILITY = "availability";
export const NAME = "name";
export const PROFESSION = "profession";
export const SENIORITY = "seniority";
export const STATUS = "status";
export const LOCATION = "location";
export const TEAM_HEADER = "team_header";
